import { bbox, circle, featureCollection } from "@turf/turf";

import { MapBounds } from "~/modules/map/components/MapButtonFitBounds/types";
import { PLANNER_MAP_POINT_RADIUS_MARGIN_KM } from "~/modules/plannerV2/constants/map";

export function calculateRouteScreenBounds(
    areas: Array<{ location: GeoJSON.Point }>,
    pickupPoints: Array<{ locationPoint: GeoJSON.Point }>,
): MapBounds | null {
    if (areas.length === 0 && pickupPoints.length === 0) {
        return null;
    }

    return {
        bbox: bbox(
            featureCollection([
                ...areas.map(area => circle(area.location, PLANNER_MAP_POINT_RADIUS_MARGIN_KM)),
                ...pickupPoints.map(point => circle(point.locationPoint, PLANNER_MAP_POINT_RADIUS_MARGIN_KM)),
            ]),
        ),
        kind: "route",
    };
}
